export default __webpack_public_path__ + "static/media/rawpixel.8e59b8b6.jpg";